<template>
  <header
    class="container-grid container lg:mt-section mb-10 sm:mb-20 lg:mb-24"
  >
    <div class="col-span-full md:col-span-6">
      <div class="grid gap-3 xs:gap-4 md:gap-6 my-10 lg:my-0">
        <div>
          <p v-if="$slots.tagline || tagline" class="md:text-xl">
            <slot name="tagline">
              {{ tagline }}
            </slot>
          </p>
          <h1 class="text-balance font-bold h1 lg:text-6xl">
            <slot name="title">
              {{ title }}
            </slot>
          </h1>
        </div>

        <div
          v-if="$slots.date"
          class="text-2xl xxs:text-2xl xs:text-3xl lg:text-4xl font-bold"
        >
          <slot name="date" />
        </div>

        <slot name="after" />
      </div>
    </div>
    <div
      v-if="$slots.image || image"
      class="lg:!w-full col-span-full md:col-span-6 -mx-spacer md:mx-0"
    >
      <slot name="image" :image-style="imageStyle">
        <MediaImage
          v-if="image"
          v-blokkli-droppable="{
            name: blokkliFields?.image,
          }"
          v-bind="image"
          :image-style="imageStyle"
          class="block"
          hide-caption
          img-class="object-contain sm:min-h-[400px] sm:max-h-[calc(100vh-180px)] xl:max-h-none xl:min-h-0"
        />
      </slot>
    </div>
  </header>
</template>

<script setup lang="ts">
import type { MediaImageFragment } from '#graphql-operations'

const { maxWidthForCols, breakpoints } = useTailwind()

defineProps<{
  title?: string
  tagline?: string
  image?: MediaImageFragment
  blokkliFields?: {
    image?: string
  }
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  sizes: {
    default: breakpoints.xs,
    xs: breakpoints.sm,
    sm: breakpoints.md,
    md: breakpoints.lg,
    lg: maxWidthForCols('lg', 6),
  },
})
</script>
